import { gql, useQuery } from '@apollo/client';

export type TechnologyListData = {
  technologyList: string[];
};

const GET_TECHNOLOGY_LIST = gql`
  query GetTechnologyList {
    technologyList
  }
`;

type UseTechnologiesDictionaryType = {
  data?: TechnologyListData;
  loading: boolean;
};

export const useTechnologiesDictionary = (): UseTechnologiesDictionaryType => {
  const { data, error, loading } =
    useQuery<TechnologyListData>(GET_TECHNOLOGY_LIST);

  if (error || !data) {
    // throw error;
  }

  return { data, loading };
};
